import React from "react";
import {styled} from "@reside/ui";

import {CommitWithResults} from "../types";
import {hasTemplateResultFailure} from "../utils";
import {TemplateResultCard} from "./TemplateResultCard";

const Panel = styled.div`
  padding: 16px 24px 20px;
  background: #f5f6f7;
  border-top: 1px solid #ebedf0;
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 12px;
`;

const NoResults = styled.div`
  font-size: 13px;
  color: #596973;
  padding: 8px 0;
`;

export const CommitDetailPanel = ({
  commit,
}: {
  commit: CommitWithResults;
}): JSX.Element => {
  if (commit.template_results.length === 0) {
    return (
      <Panel>
        <NoResults>No template results for this commit.</NoResults>
      </Panel>
    );
  }

  const sorted = [...commit.template_results].sort((a, b) => {
    const aFailed = hasTemplateResultFailure(a);
    const bFailed = hasTemplateResultFailure(b);
    if (aFailed && !bFailed) return -1;
    if (!aFailed && bFailed) return 1;
    return 0;
  });

  return (
    <Panel>
      <CardsGrid>
        {sorted.map((result) => (
          <TemplateResultCard key={result.id} result={result} />
        ))}
      </CardsGrid>
    </Panel>
  );
};
